import { LOGIN_SOURCE, LOGIN_SOURCE_KEY, LoginSourceType } from "./shared-constants";

/**
 * Check if the current user logged in via any DMS system
 */
export const isDMSLogin = (): boolean => {
    const loginSource = localStorage.getItem(LOGIN_SOURCE_KEY)?.toString();
    return (
        loginSource === LOGIN_SOURCE.DMS_INFINITY ||
        loginSource === LOGIN_SOURCE.DMS_IDEAL ||
        loginSource === LOGIN_SOURCE.DMS_ASPEN ||
        loginSource === LOGIN_SOURCE.DMS_DIS
    );
};

/**
 * Check if login source is Ideal or Infinity
 */
export const isIdealOrInfinityLogin = (): boolean => {
    const loginSource = localStorage.getItem(LOGIN_SOURCE_KEY)?.toString();
    return (
        loginSource === LOGIN_SOURCE.DMS_IDEAL ||
        loginSource === LOGIN_SOURCE.DMS_INFINITY
    );
};

/**
 * Get the current login source from localStorage
 */
export const getLoginSource = (): string | null => {
    return localStorage.getItem(LOGIN_SOURCE_KEY);
};

/**
 * Set the login source in localStorage
 */
export const setLoginSource = (source: LoginSourceType): void => {
    localStorage.setItem(LOGIN_SOURCE_KEY, source);
};

/**
 * Clear the login source from localStorage
 */
export const clearLoginSource = (): void => {
    localStorage.removeItem(LOGIN_SOURCE_KEY);
};
